exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media not all and (min-resolution:.001dpcm){@media{#wacg-wrapper .safari-clear-fix{flex-basis:49%!important}}}", ""]);

// exports
